type ConflictModalCallbacks = {
  resolve: ((value: unknown) => void) | null;
  reject: ((reason: unknown) => void) | null;
};

// Module-level store for Promise callbacks (not in Redux to avoid serialization issues)
const callbacks: ConflictModalCallbacks = {
  resolve: null,
  reject: null,
};

export const setConflictModalCallbacks = (
  resolve: (value: unknown) => void,
  reject: (reason: unknown) => void
): void => {
  callbacks.resolve = resolve;
  callbacks.reject = reject;
};

export const resolveConflictModal = (value: unknown): void => {
  if (callbacks.resolve) {
    callbacks.resolve(value);
    clearConflictModalCallbacks();
  }
};

export const rejectConflictModal = (reason: unknown): void => {
  if (callbacks.reject) {
    callbacks.reject(reason);
    clearConflictModalCallbacks();
  }
};

export const clearConflictModalCallbacks = (): void => {
  callbacks.resolve = null;
  callbacks.reject = null;
};
